import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-prantwise-varganidar-report',
  templateUrl: './prantwise-varganidar-report.component.html',
  styleUrls: ['./prantwise-varganidar-report.component.scss'],
})
export class PrantwiseVarganidarReportComponent implements OnInit {
  isLoading: boolean = false;
  startDate = '';
  endDate = '';
  prantData;
  showPrantData = [
    { prantName: 'कोकण प्रांत' },
    { prantName: 'पश्चिम प्रांत' },
    { prantName: 'देवगिरी प्रांत' },
    { prantName: 'विदर्भ प्रांत' },
    { prantName: 'अन्य प्रांत' },
  ];
  showOtherPrantData = [];
  totalPostTotal = 0;
  totalHasteTotal = 0;
  totalMagzineTotal = 0;
  totalDigitalTotal = 0;

  constructor(
    private dialogRef: MatDialogRef<PrantwiseVarganidarReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.prantData = this.data['data'];
    // console.log(this.prantData);

    this.endDate = this.data['issuedate'];
    let weekfirstday =
      new Date(this.data['issuedate']).getDate() -
      new Date(this.data['issuedate']).getDay();
    this.startDate = formatDate(
      new Date(this.data['issuedate']).setDate(weekfirstday - 7),
      'yyyy-MM-dd',
      'en-IN',
      'GMT+0530'
    );

    this.setPrantData();
  }

  //Old Method 
  // setPrantData() {
  //   this.totalPostTotal = 0;
  //   this.totalHasteTotal = 0;
  //   this.totalMagzineTotal = 0;
  //   this.totalDigitalTotal = 0;
  //   let mahaState = this.prantData.filter((a) => {
  //     return a.state === 'महाराष्ट्र';
  //   });
  //   // console.log(mahaState);

  //   let otherState = this.prantData.filter((a) => {
  //     return a.state !== 'महाराष्ट्र';
  //   });
  //   // console.log(otherState);

  //   let otherPost = otherState.filter((a) => {
  //     return a.delivery_mode === 'टपाल';
  //   });

  //   let otherHaste = otherState.filter((a) => {
  //     return a.delivery_mode === 'हस्ते';
  //   });

  //    let otherMagzine = otherState.filter((a) => {
  //     return a.delivery_mode === 'मॅगझीन पोस्ट';
  //   });

  //    let otherDigital = otherState.filter((a) => {
  //     return a.delivery_mode === 'डिजिटल';
  //   });

  //   this.showOtherPrantData.push({
  //     name: 'अन्यप्रांत',
  //     post: otherPost.length,
  //     haste: otherHaste.length,
  //     magazine: otherMagzine.length,
  //     digital: otherDigital.length,
  //     total: otherPost.length + otherHaste.length + otherMagzine.length + otherDigital.length,
  //   });

  //   this.showOtherPrantData.push({
  //     name: 'परदेश',
  //     post: 0,
  //     haste: 0,
  //     magazine: 0,
  //     digital: 0,
  //     total: 0,
  //   });

  //   this.totalPostTotal += otherPost.length;
  //   this.totalHasteTotal += otherHaste.length;
  //   this.totalMagzineTotal += otherMagzine.length;
  //   this.totalDigitalTotal += otherDigital.length;

  //   let data = this.uniqueData(mahaState, (a) => a.prant_name);
  //   // console.log(data);

  //   for (let i = 0; i < data.length; i++) {
  //     let district = mahaState.filter((a) => {
  //       return a.prant_name === data[i]['prant_name'];
  //     });

  //     let uniqueDistrict = this.uniqueData(district, (a) => a.district);
  //     // console.log(uniqueDistrict);

  //     let prantData = [];
  //     let postTotal = 0;
  //     let hasteTotal = 0;
  //     let magzineTotal = 0;
  //     let digitalTotal = 0;

  //     for (let j = 0; j < uniqueDistrict.length; j++) {
  //       let districtData = district.filter((a) => {
  //         return a.district === uniqueDistrict[j]['district'];
  //       });

  //       let post = districtData.filter((a) => {
  //         return a.delivery_mode === 'टपाल';
  //       });

  //       let haste = districtData.filter((a) => {
  //         return a.delivery_mode === 'हस्ते';
  //       });

  //       let magazine = districtData.filter((a) => {
  //         return a.delivery_mode === 'मॅगझीन पोस्ट';
  //       });

  //       let digital = districtData.filter((a) => {
  //         return a.delivery_mode === 'डिजिटल';
  //       });

  //       postTotal += post.length;
  //       hasteTotal += haste.length;
  //        magzineTotal += magazine.length;
  //        digitalTotal += digital.length;

  //       prantData.push({
  //         districtName: uniqueDistrict[j]['district'],
  //         post: post.length,
  //         haste: haste.length,
  //         magazine: magazine.length,
  //         digital: digital.length,
  //         total: post.length + haste.length + magazine.length + digital.length,
  //       });

  //       // console.log(districtData);
  //       if (j === uniqueDistrict.length - 1) {
  //         prantData.push({
  //           name: 'एकूण',
  //           postTotal,
  //           hasteTotal,
  //           magzineTotal,
  //           digitalTotal,
  //           total: postTotal + hasteTotal + magzineTotal + digitalTotal,
  //         });
  //       }
  //     }

  //     this.totalPostTotal += postTotal;
  //     this.totalHasteTotal += hasteTotal;
  //     this.totalMagzineTotal += magzineTotal;
  //     this.totalDigitalTotal += digitalTotal;

  //     // this.showPrantData.push({
  //     //   prantName: data[i]['prant_name'],
  //     //   data: prantData,
  //     // });
  //     this.showPrantData.map((a) => {
  //       if (a.prantName === data[i]['prant_name']) {
  //         a['data'] = prantData;
  //       }
  //     });
  //   }
  //   this.isLoading = false;
  //   // console.log(this.showPrantData);

  //   // console.log(
  //   //   this.showPrantData.sort((a: any, b: any) => {
  //   //     return a.prantName.localeCompare(b.prantName);
  //   //   })
  //   // );
  // }

  // uniqueData(data, key) {
  //   return [...new Map(data.map((a) => [key(a), a])).values()];
  // }

  setPrantData() {
  this.totalPostTotal = 0;
  this.totalHasteTotal = 0;
  this.totalMagzineTotal = 0;
  this.totalDigitalTotal = 0;

  let mahaState = this.prantData.filter((a) => {
    return a.state === 'महाराष्ट्र' || (a.state === 'गोवा' && a.prant_name === 'कोकण प्रांत');
  });

  let otherState = this.prantData.filter((a) => {
    return !(a.state === 'महाराष्ट्र' || (a.state === 'गोवा' && a.prant_name === 'कोकण प्रांत'));
  });

  let otherPost = otherState.filter((a) => a.delivery_mode === 'टपाल');
  let otherHaste = otherState.filter((a) => a.delivery_mode === 'हस्ते');
  let otherMagzine = otherState.filter((a) => a.delivery_mode === 'मॅगझीन पोस्ट');
  let otherDigital = otherState.filter((a) => a.delivery_mode === 'डिजिटल');

  this.showOtherPrantData.push({
    name: 'अन्यप्रांत',
    post: otherPost.length,
    haste: otherHaste.length,
    magazine: otherMagzine.length,
    digital: otherDigital.length,
    total: otherPost.length + otherHaste.length + otherMagzine.length + otherDigital.length,
  });

  this.showOtherPrantData.push({
    name: 'परदेश',
    post: 0,
    haste: 0,
    magazine: 0,
    digital: 0,
    total: 0,
  });

  this.totalPostTotal += otherPost.length;
  this.totalHasteTotal += otherHaste.length;
  this.totalMagzineTotal += otherMagzine.length;
  this.totalDigitalTotal += otherDigital.length;

  let data = this.uniqueData(mahaState, (a) => a.prant_name);

  for (let i = 0; i < data.length; i++) {
    let district = mahaState.filter((a) => a.prant_name === data[i]['prant_name']);
    let uniqueDistrict = this.uniqueData(district, (a) => a.district);

    let prantData = [];
    let postTotal = 0;
    let hasteTotal = 0;
    let magzineTotal = 0;
    let digitalTotal = 0;

    for (let j = 0; j < uniqueDistrict.length; j++) {
      let districtData = district.filter((a) => a.district === uniqueDistrict[j]['district']);

      let post = districtData.filter((a) => a.delivery_mode === 'टपाल');
      let haste = districtData.filter((a) => a.delivery_mode === 'हस्ते');
      let magazine = districtData.filter((a) => a.delivery_mode === 'मॅगझीन पोस्ट');
      let digital = districtData.filter((a) => a.delivery_mode === 'डिजिटल');

      postTotal += post.length;
      hasteTotal += haste.length;
      magzineTotal += magazine.length;
      digitalTotal += digital.length;

      prantData.push({
        districtName: uniqueDistrict[j]['district'],
        post: post.length,
        haste: haste.length,
        magazine: magazine.length,
        digital: digital.length,
        total: post.length + haste.length + magazine.length + digital.length,
      });

      if (j === uniqueDistrict.length - 1) {
        prantData.push({
          name: 'एकूण',
          postTotal,
          hasteTotal,
          magzineTotal,
          digitalTotal,
          total: postTotal + hasteTotal + magzineTotal + digitalTotal,
        });
      }
    }

    this.totalPostTotal += postTotal;
    this.totalHasteTotal += hasteTotal;
    this.totalMagzineTotal += magzineTotal;
    this.totalDigitalTotal += digitalTotal;

    this.showPrantData.map((a) => {
      if (a.prantName === data[i]['prant_name']) {
        a['data'] = prantData;
      }
    });
  }

  this.isLoading = false;
}

uniqueData(data, key) {
  return [...new Map(data.map((a) => [key(a), a])).values()];
}


  exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }


//Correct Old Method 
// printPage() {
//   const printContent = document.getElementById('print-section')?.innerHTML;
//   if (!printContent) {
//     console.error("Print section not found!");
//     return;
//   }

//   const printWindow = window.open('', '', 'width=1200,height=1000,top=50,left=50,scrollbars=yes');

//   if (printWindow) {
//     printWindow.document.open();
//     printWindow.document.write(`
//       <html>
//         <head>
//           <title>Print Report</title>

//           <style>

//             /* -----------------------------
//                Set A4 Portrait Page
//             ------------------------------ */
//             @page { 
//               size: A4 portrait !important;
//               margin: 12mm 6mm 12mm 12mm !important; /* RIGHT SIDE REDUCED */
//             }

//             @media print {

//               @page {
//                 size: A4 portrait !important;
//                 margin: 12mm 6mm 12mm 12mm !important; /* RIGHT FIX */
//               }

//               body {
//                 font-family: Arial, sans-serif;
//                 font-size: 10px;
//                 margin: 0;
//                 padding: 0;
//               }

//               /* FIX: table width reduced to avoid cutting last border */
//               table {
//                 width: 80% !important;
//                 border-collapse: collapse;
//                 table-layout: fixed;
//                 page-break-inside: auto;
//               }

//               /* Uniform borders */
//               table, th, td {
//                 border: 1px solid #000 !important;
//               }

//               th, td {
//                 padding: 2px 4px;
//                 font-size: 10px;
//                 word-break: break-word;
//               }

//               tr {
//                 page-break-inside: avoid;
//               }

//               .noPrint {
//                 display: none !important;
//               }
//             }

//             /* Screen View */
//             body {
//               font-family: Arial, sans-serif;
//               font-size: 10px;
//             }

//             table {
//               width: 80% !important; /* SAME FIX ON SCREEN */
//               border-collapse: collapse;
//             }

//             table, th, td {
//               border: 1px solid black !important;
//             }

//             th, td {
//               padding: 2px 4px;
//               text-align: center;
//             }
//           </style>

//         </head>

//         <body>
//           <div>${printContent}</div>

//           <script>
//             window.onload = function() {
//               window.print();
//               setTimeout(() => window.close(), 500);
//             };
//           </script>
//         </body>
//       </html>
//     `);

//     printWindow.document.close();

//   } else {
//     console.error("Failed to open print window.");
//   }
// }

printPage() {
  const printContent = document.getElementById('print-section')?.innerHTML;
  if (!printContent) {
    console.error("Print section not found!");
    return;
  }

  const printWindow = window.open('', '', 'width=1200,height=1000,top=50,left=50,scrollbars=yes');

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Report</title>

          <style>

            @page { 
              size: A4 portrait !important;
              margin: 12mm 6mm 12mm 12mm !important;
            }

            @media print {

              @page {
                size: A4 portrait !important;
                margin: 12mm 6mm 12mm 12mm !important;
              }

              body {
                font-family: Arial, sans-serif;
                font-size: 10px;
                margin: 0;
                padding: 0;
              }

              table {
                width: 80% !important;
                border-collapse: collapse;
                table-layout: fixed;
                page-break-inside: auto;
              }

              table, th, td {
                border: 1.2px solid #000 !important;
              }

              th, td {
                padding: 2px 4px;
                font-size: 10px;
                word-break: break-word;
                text-align: center;
              }

              tr { page-break-inside: avoid; }
              .noPrint { display: none !important; }

              /* ---------------------------------------------------
                 ✔ WORKING FIX: Make Prant Names Bold
                 (पश्चिम प्रांत, उत्तर प्रांत, दक्षिण प्रांत, etc.)
                 --------------------------------------------------- */
              td.prant-name, th.prant-name {
                font-weight: bold !important;
              }

              /* ---------------------------------------------------
                 ✔ WORKING FIX: Make "एकूण" & its values bold
                 --------------------------------------------------- */
              td.total-bold, th.total-bold {
                font-weight: bold !important;
              }
            }


            /* Screen View (Optional) */
            body {
              font-family: Arial, sans-serif;
              font-size: 10px;
            }

            table {
              width: 80% !important;
              border-collapse: collapse;
            }

            table, th, td {
              border: 1.2px solid black !important;
            }

            th, td {
              padding: 2px 4px;
              text-align: center;
            }

            td.prant-name, th.prant-name {
              font-weight: bold !important;
            }

            td.total-bold, th.total-bold {
              font-weight: bold !important;
            }

          </style>

        </head>

        <body>
          <div>${printContent}</div>

          <script>
            window.onload = function() {
              window.print();
              setTimeout(() => window.close(), 500);
            };
          </script>
        </body>
      </html>
    `);

    printWindow.document.close();

  } else {
    console.error("Failed to open print window.");
  }
}



}
